import {Notification, NotificationProps, Typography} from '@genestack/ui';
import React from 'react';

/** To be shown when editor couldn't find requested node */
export const NodeNotFoundNotification = (props: NotificationProps) => (
    <Notification {...props}>
        <Typography intent="warning">Requested node not present in the document</Typography>
    </Notification>
);
